<template>
  <div class="ClassifyList">
    <XTable
        :api="getClassTree"
        :state="classifyList"
        :columns="columns"
        :loading="classifyListLoading"
        :tableSize="tableSize"
        :hasPagination="hasPagination"
        :layout="layout"
    ></XTable>
  </div>
</template>

<script>
import XTable from "@/components/XTable/index.vue";
import {mapActions, mapMutations, mapState} from "vuex";

export default {
  name: "ClassifyList",
  components: {XTable},
  data() {
    return {
      hasPagination: false,
      tableSize: "small",
      layout: "",
    };
  },
  computed: {
    ...mapState("teachingCenter", ["classifyListLoading", "classifyList"]),
    // ...mapState("administrativeCenter", ["tenantDepartmentUserList"]),
    ...mapState("user", ["permissionCode"]),
    columns: function () {
      const self = this;
      const columns = [
        {
          prop: "name",
          label: "目录名称",
        },
        {
          prop: "code",
          label: "目录编号",
        },
        {
          prop: "subjectNumber",
          label: "系列数量",
          render(h, scope) {
            return (
                <div>
                  <span>{(scope.row && scope.row.subjectNumber) || 0}</span>
                </div>
            );
          },
        },
      ];
      if (this.permissionCode.has('research:dir:manager')) {
        let subjectManager = this.permissionCode.has('research:subject:manager');
        columns.push({
          label: "操作",
          width: "400",
          render(h, scope) {
            return (
                <div>
                  <el-button
                      onClick={() => {
                        self.handleEdit(scope.row);
                      }}
                      size="mini"
                      type="primary"
                      plain
                  >
                    编辑
                  </el-button>
                  <el-button
                      onClick={() => {
                        self.handleDelete(scope.row);
                      }}
                      size="mini"
                      type="danger"
                      plain
                  >
                    删除
                  </el-button>
                  {scope.row.parentId === 0 && scope.row.subjectNumber === 0 && (
                      <el-button
                          onClick={() => {
                            self.handleAddClassify(scope.row);
                          }}
                          size="mini"
                          type="primary"
                          plain
                      >
                        新增子目录
                      </el-button>
                  )}
                  {subjectManager && !scope.row.children && (
                      <el-button
                          onClick={() => {
                            self.handleAddSeries(scope.row);
                          }}
                          size="mini"
                          type="primary"
                          plain
                      >
                        去新增系列
                      </el-button>
                  )}
                </div>
            );
          },
        })
      }
      return columns;
    }
  },
  methods: {
    // ...mapActions("administrativeCenter", ["getTenantDepartmentUser"]),
    ...mapActions("teachingCenter", ["getClassTree", "deleteClassTree"]),
    ...mapMutations("teachingCenter", ["setData"]),
    handleDelete(row) {
      if (row.subjectNumber > 0) {
        this.$confirm(
            "该分类下已有系列课程，请先更换到别的分类后重试。",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
        )
            .then(async () => {
            })
            .catch(() => {
            });
      } else if (row.children) {
        this.$confirm("删除后该分类下子分类也会同步删除。", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
            .then(async () => {
              await this.deleteClassTree({
                id: row.id,
              });
              await this.getClassTree({
                parentId: null,
              });
            })
            .catch(() => {
            });
      } else {
        this.$confirm("是否确认删除该分类?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
            .then(async () => {
              await this.deleteClassTree({
                id: row.id,
              });
              await this.getClassTree({
                parentId: null,
              });
            })
            .catch(() => {
            });
      }
    },
    async handleEdit(row) {
      localStorage.setItem("classifyDetail", JSON.stringify(row));
      await this.$router.push(
          {
            name: "AddClassify",
            params: {
              type: "edit",
              id: this.$Base64.encode(row.parentId),
            },
          },
          () => {
          }
      );
    },
    async handleAddClassify(row) {
      await this.$router.push(
          {
            name: "AddClassify",
            params: {
              type: "add",
              id: this.$Base64.encode(row.id),
            },
          },
          () => {
          }
      );
    },
    async handleAddSeries(row) {
      // await this.getTenantDepartmentUser({
      //   roleName: "老师",
      //   page: null,
      //   size: null,
      // });
      //   如果没有老师，跳转至新增人员
      // if (this.tenantDepartmentUserList.data.length < 1) {
      //   this.$confirm(
      //       "您的人员库中老师人数为0,请先去人员管理新增老师!",
      //       "提示",
      //       {
      //         confirmButtonText: "确定",
      //         cancelButtonText: "取消",
      //         type: "warning",
      //       }
      //   )
      //       .then(async () => {
      //         await this.$router.push(
      //             {
      //               name: "AddPerson",
      //               params: {
      //                 type: "add",
      //               },
      //             },
      //             () => {
      //             }
      //         );
      //       })
      //       .catch(() => {
      //       });
      //   return;
      // }
      this.$router.push(
          {
            name: "AddEnterpriseSeries",
            params: {
              type: "add",
              id: row.id,
            },
          },
          () => {
          }
      );
    },
  },
};
</script>

<style lang="scss" scoped></style>
